/* Home V2: hero brand strip. The three offering blocks (Future Fabric / TenX
   Labs / DayOne) are anchors to #pe-systems; without JS a click just jumps
   there. Here we enhance the click to also OPEN the matching pillar's panel in
   the capability-systems section, then land it the same way an orbit click does
   (panel bottom at the fold, head clear of the fixed header). Mirrors
   20-orbits.js activate() so both entry points feel identical. */
(function () {
  'use strict';

  var strip = document.querySelector('.hv2-brand-strip');
  if (!strip) { return; }

  var reduce = window.PEHomeV2 && window.PEHomeV2.reduce;

  function openAndScroll(idx) {
    /* Open the pillar now if 30-pillars.js has exposed its hook; otherwise
       leave a flag it reads at init (script-order / cross-page safety). */
    if (window.PEHomeV2 && typeof window.PEHomeV2.openPillar === 'function') {
      window.PEHomeV2.openPillar(idx);
    } else {
      try { sessionStorage.setItem('hv2OpenPillar', String(idx)); } catch (e) { /* private mode */ }
    }

    var target = document.getElementById('pillars') || document.getElementById('pe-systems');
    if (target) {
      var behavior = reduce ? 'auto' : 'smooth';
      /* Land the opened panel with its BOTTOM at the fold, but never scroll so
         far that the panel head slips behind the fixed header (short viewports
         keep the head + first offering visible). Uses the panel's FULL height
         (inner.offsetHeight) rather than its mid-animation height. */
      var openEl = target.querySelector('.pillar.is-open');
      var inner = openEl && openEl.querySelector('.p-inner');
      var fullH = inner ? inner.offsetHeight : target.offsetHeight;
      var topAbs = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
      var bottomAlignY = topAbs + fullH - window.innerHeight + 24; /* 24px gap above the fold */
      var topAlignY = topAbs - 80; /* head just clear of the fixed header */
      window.scrollTo({ top: Math.max(0, Math.min(bottomAlignY, topAlignY)), behavior: behavior });
    }

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#pe-systems');
    } else {
      window.location.hash = 'pe-systems';
    }
  }

  strip.addEventListener('click', function (e) {
    var brand = e.target.closest ? e.target.closest('.hv2-brand') : null;
    if (!brand) { return; }
    var idx = brand.getAttribute('data-pillar-index');
    if (idx === null) { return; }
    e.preventDefault();
    openAndScroll(idx);
  });
})();
